export const TRANSACTION_VOLUME_CHART_ENDPOINT = '/transaction-api/chart/v1/transactions-volume';
export const TRANSACTION_TIMERS_VOLUME_CHART_ENDPOINT = '/transaction-api/chart/v1/transaction-timers-volume';
export const TRANSACTION_TIMERS_DURATION_CHART_ENDPOINT = '/transaction-api/chart/v1/transaction-timers-duration';
export const TRANSACTION_TIMERS_DURATION_BY_USER_CHART_ENDPOINT = '/transaction-api/chart/v1/transaction-timers-duration-by-user';
export const SPOT_FILL_RATE_CHART_ENDPOINT = '/transaction-api/chart/v1/spot-fill-rate';
